import { animate, style, transition, trigger } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { FeedbackService } from '../services/feedback.service';

@Component({
  selector: 'app-feedback-modal',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatSnackBarModule,
    MatProgressSpinnerModule,
    FormsModule
  ],
  templateUrl: './feedback-modal.component.html',
  styleUrls: ['./feedback-modal.component.css'],
  animations: [
    trigger('successMessage', [
      transition(':enter', [
        style({ opacity: 0, transform: 'scale(0.8)' }),
        animate('300ms ease-out', style({ opacity: 1, transform: 'scale(1)' }))
      ]),
      transition(':leave', [animate('300ms ease-in', style({ opacity: 0, transform: 'scale(0.8)' }))])
    ])
  ]
})
export class FeedbackModalComponent {
  feedbackInput = '';
  feedbackSubmitted = false;
  feedbackSubmittedLoader = false;

  constructor(
    private dialogRef: MatDialogRef<FeedbackModalComponent>,
    private feedbackService: FeedbackService,
    private snackBar: MatSnackBar
  ) {}

  sendFeedback() {
    if (!this.feedbackInput || this.feedbackInput.trim().length === 0) {
      return;
    }
    this.feedbackSubmittedLoader = true;

    this.feedbackService.submitFeedback(this.feedbackInput).subscribe({
      next: response => {
        console.log('Feedback submitted successfully:', response);

        // Mostrar mensaje de éxito
        this.feedbackSubmitted = true;

        // Resetear después de 2 segundos
        setTimeout(() => {
          this.dialogRef.close(this.feedbackInput);
          this.feedbackInput = '';
          setTimeout(() => {
            this.feedbackSubmitted = false;
          }, 500);
        }, 2000);
      },
      error: error => {
        console.error('Error submitting feedback:', error);
        this.feedbackSubmittedLoader = false;
        this.snackBar.open('There was an error submitting your feedback. Please try again.', 'Close', {
          duration: 5000
        });
      }
    });
  }
}
